// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24MwS","productName":"Table_productName__lFK0s"};